import { useEffect, useRef } from "react";
import "./MapaAnimacao.css";
import TrilhosPaths from "./TrilhosPaths";

export default function MapaAnimacao({
  mapSrc,
  map   = { left: 0,  top: 0,  width: 818.73, height: 1080 },
  rails = { left: 38, top: 45, width: 728,    height: 885  },
  baseSpeed = 90, // (não usado agora, mas deixei)
  className = "",
}) {
  const svgRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    const railsPaths = svg.querySelectorAll("#rails path");

    railsPaths.forEach((p, i) => {
      const L = p.getTotalLength();
      p.style.setProperty("--len", L.toFixed(2));
      p.style.setProperty("--drawDelay", `${(i * 0.03).toFixed(2)}s`);
    });
  }, []);

  return (
    <div className={`mapa-stage ${className}`}>
      <img
        src={mapSrc}
        alt=""
        className="map-img"
        style={{
          left: `${map.left}px`,
          top: `${map.top}px`,
          width: `${map.width}px`,
          height: `${map.height}px`,
        }}
        draggable={false}
      />

      <svg
        ref={svgRef}
        className="rail-svg"
        style={{
          left: `${rails.left}px`,
          top: `${rails.top}px`,
          width: `${rails.width}px`,
          height: `${rails.height}px`,
        }}
        viewBox="0 0 735 883"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Trilhos animados"
      >
        <TrilhosPaths />
        {/* sem layer de fluxo / sem trens */}
      </svg>
    </div>
  );
}
